import { Component, ElementRef, Optional, ViewChild } from '@angular/core';
import { HeroImageInputDialogComponent } from './hero-image-input-dialog/hero-image-input-dialog.component';
import { NbDialogRef, NbMenuService, NbDialogService } from '@nebular/theme';
import { BloglistLayoutEnum, HeroLayoutEnum, RendererType } from '@urbannex/storethemes';
import { HomeInputGridComponent } from '../home-input-grid/home-input-grid.component';

@Component({
  selector: 'ngx-home-input-hero-image',
  templateUrl: './home-input-hero-image.component.html',
  styleUrls: ['./home-input-hero-image.component.scss']
})
export class HomeInputHeroImageComponent {
  activeInputMenuItem:string;
  title:string;
  collapsed:boolean = true;

  @ViewChild('expandable',{read:ElementRef}) expandable:ElementRef<HTMLElement>

  constructor(
    @Optional() protected ref: NbDialogRef<HomeInputGridComponent>,
    private menuService:NbMenuService,
    private el:ElementRef<HTMLElement>,
    private dialogService: NbDialogService
    ) { }

  ngOnInit(): void {
    this.menuService.onItemClick().subscribe(menuBag =>{
      let selectedItem = menuBag.item;
      if(selectedItem != undefined){
        this.activeInputMenuItem = selectedItem.title;
      }
    })
  }

  ngAfterViewInit():void{
    const overlayPane = this.el.nativeElement.parentElement.parentElement;
    const overlayWrapper = this.el.nativeElement.parentElement.parentElement.parentElement;
    setTimeout(() => {
      overlayWrapper.style.left ="0px";
      overlayWrapper.style.justifyContent = "flex-end";
      overlayWrapper.style.right = "16px";
      //overlayPane.style.width = "256px";
      overlayPane.style.marginRight = "16px";
      overlayPane.style.marginTop = "18px";
      overlayPane.style.display = "block";
    }, 1);


    //return el.parentElement.parentElement.parentElement.parentElement;
  }

  toggleContainer(){
    this.expandable.nativeElement.classList.toggle("collapsed");
  }

  getLayoutClass(numberOfCells:number):HeroLayoutEnum{
    switch (numberOfCells) {
      case 1:
        return HeroLayoutEnum.LAYOUT_1        
        break;
      case 2:
        return HeroLayoutEnum.LAYOUT_2
        break;
      case 3:
        return HeroLayoutEnum.LAYOUT_3
        break;
      case 4:
        return HeroLayoutEnum.LAYOUT_4
        break;
      case 5:
        return HeroLayoutEnum.LAYOUT_5
        break;
      case 6:
        return HeroLayoutEnum.LAYOUT_6
        break;
      default:
        return HeroLayoutEnum.LAYOUT_1
        break;
    }

  }

  createGrid(numberOfElements){
    const layoutClass = this.getLayoutClass(numberOfElements);
    console.log(layoutClass);
    this.dialogService.open(HeroImageInputDialogComponent, {
      context:{
        rendererType:RendererType.HEROIMAGE,
        layoutClass:layoutClass,
        title:"Adding new blog list section with layout: "+layoutClass
      }
    }).onClose.subscribe(() => {
      console.log("closing")
    })
    this.ref.close();
  }

  close(e){
    this.ref.close();
  }
}
